<template>
    <Dropdown
        v-model="selectedLanguage"
        @change="setLanguage()"
        :options="dropdownOptions"
        placeholder=""
        class="xl:w-14rem w-fit"
        :pt-options="{
            mergeProps: false,
            mergeSections: false,
        }"
        :pt="{
            root: () => ({
                class: 'flex gap-4 items-center border-none bg-transparent hover:opacity-50 hover:cursor-pointer',
            }),
            input: () => ({
                class: 'p-0 sm:p-0',
            }),
            panel: '!mt-2',
            wrapper: {
                class: '!max-h-[300px] text-gray-700 border-0 rounded-md shadow-none !bg-background-app-filled overflow-auto',
            },
            list: 'py-3 list-none m-0',
            item: () => ({
                class: 'py-1 hover:none px-0 hover:cursor-pointer flex justify-center overflow-hidden',
            }),
            trigger: 'text-sidebar-step-title-i-c',
        }"
    >
        <template #value="slotProps">
            <img v-if="slotProps.value" :alt="slotProps.value.code" :src="slotProps.value.flag" class="size-7" />
        </template>
        <template #option="slotProps">
            <img :alt="slotProps.option.code" :src="slotProps.option.flag" class="size-7 hover:opacity-50" />
        </template>
    </Dropdown>
</template>

<script setup lang="ts">
import { usePrimeVue } from 'primevue/config';
import Dropdown from 'primevue/dropdown';
import { computed, ref, watch } from 'vue';
import languages, { ILanguage } from '@/codelists/Languages';
import { useUserStore } from '@/stores/user';

const primevue = usePrimeVue();
const userStore = useUserStore();
const selectedLanguage = ref<ILanguage>();

const initLanguage = () => {
    const languageCode = userStore.getLanguageCode;
    if (languageCode) {
        selectedLanguage.value = languages.find((l) => l.code === languageCode);
    }
};

const dropdownOptions = computed(() => {
    return languages.filter((l) => l.code !== selectedLanguage.value?.code);
});

watch(
    () => userStore.getLanguageCode,
    () => {
        initLanguage();
    },
    {
        immediate: true,
    }
);

const setLanguage = async () => {
    await userStore.setLanguage(selectedLanguage.value.code, primevue);
};
</script>
